// extracted by mini-css-extract-plugin
export default {"box":"Right_box__guA-W"};